import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme)
	const ex2= await getThemePic(data?.customTheme, 'ex-2')

	return {
		"id": id,
		"elements": [{
			"type": "text",
			"id": "TwNc1bur8V",
			"width": 862.5,
			"height": 48,
			"left": 68.75,
			"top": 29.95,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#333",
			"content": `<p style=\"text-align: center;\"><span style=\"font-size: 28px;\"><span style=\"font-family: +mn-lt;\">${title}</span></span></p>`,
			"lineHeight": 1,
			"fill": "",
			"vertical": false
		},
		{
			"type": "shape",
			"id": "P6TVaBFXYX",
			"width": 873.16,
			"height": 271.44,
			"left": 63.42,
			"top": 119.12,
			"viewBox": [
				200,
				200
			],
			"path": "M 0 0 L 200 0 L 200 200 L 0 200 Z",
			"fill": "none",
			"fixedRatio": false,
			"rotate": 0,
			"outline": {
				"color": "#3f3f3f",
				"width": 0,
				"style": "solid"
			},
			"text": {
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: Arial;\">&nbsp;</span></p>",
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"align": "middle"
			},
			"flipH": false,
			"flipV": false
		},
		{
			"type": "image",
			"id": "9l1z5XfWMX",
			"src": ex2,
			"width": 862.07,
			"height": 260.52,
			"left": 68.96,
			"top": 124.58,
			"fixedRatio": true,
			"rotate": 0,
			"flipH": false,
			"flipV": false
		},
		{
			"type": "text",
			"id": "02poBWD1XA",
			"width": 224.79,
			"height": 56,
			"left": 387.6,
			"top": 411.21,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#333",
			"content": `<p style=\"text-align: center;\"><span style=\"font-size: 36px;\">${serial}</span></p>`,
			"lineHeight": 1,
			"outline": {
				"color": "#000",
				"width": 0,
				"style": "solid"
			},
			"fill": "",
			"vertical": false
		},
		{
			"type": "line",
			"id": "jX9AxFXxaV",
			"width": 0.75,
			"left": 366.935,
			"top": 467.21,
			"start": [
				266.13,
				0
			],
			"end": [
				0,
				0
			],
			"style": "dashed",
			"color": "#3f3f3f",
			"points": [
				"",
				""
			]
		}
		],
		background
	};

}